exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list .project-status[data-v-74a30572] {\n  background: #ffffff;\n  padding: 30px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 30px;\n  border-radius: 3px;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n}\n.list .project-status .name[data-v-74a30572] {\n    font-weight: 600;\n}\n.list .project-status .type select[data-v-74a30572] {\n    padding: 4px 10px;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    cursor: pointer;\n    border-radius: 3px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-74a30572","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/settings/components/projectStatuses.vue
// module id = 579
// module chunks = 0